import moment from "moment-timezone";

export const linkTitle = (title: string) => {
	return title.trim()
		.replace('@', 'at')
		.replace('&', 'and')
		.replace('\'', '')
		.replace('(', '').replace(')', '').replace('[', '').replace(']', '').replace('{', '').replace('}', '').replace(',', '').replace('.', '')
		.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase();
}

export const currency = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', currencyDisplay: 'symbol' });


export const getLocalDate = (date: moment.MomentInput) : Date => {
	var localDateOffset = new Date().getTimezoneOffset();
	var torontoDateOffset = moment(date).isDST() ? 240 : 300;
	return moment(date).add(localDateOffset - torontoDateOffset, 'minutes').toDate();
}

export const getRemoteDate = (date: moment.MomentInput) : Date => {
	var localDateOffset = new Date().getTimezoneOffset();
	var torontoDateOffset = moment(date).isDST() ? 240 : 300;
	return moment(date).add(torontoDateOffset - localDateOffset, 'minutes').toDate();
}